const API_BASE = process.env.REACT_APP_API_URL || "/api/v1";
const TOKEN_KEY = "builder_token";
const USER_KEY = "builder_user";
const BUILDER_SCOPE_KEY = "builder_scope_id";

export const storage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (token) => localStorage.setItem(TOKEN_KEY, token),
  getUser: () => {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || "null");
    } catch {
      return null;
    }
  },
  setUser: (user) => localStorage.setItem(USER_KEY, JSON.stringify(user)),
  getBuilderScope: () => localStorage.getItem(BUILDER_SCOPE_KEY) || "",
  setBuilderScope: (id) => {
    if (id) localStorage.setItem(BUILDER_SCOPE_KEY, id);
    else localStorage.removeItem(BUILDER_SCOPE_KEY);
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(BUILDER_SCOPE_KEY);
  },
};

const cleanQuery = (query = {}) =>
  Object.fromEntries(
    Object.entries(query).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

export class ApiError extends Error {
  constructor(message, statusCode = 500, errors = []) {
    super(message);
    this.statusCode = statusCode;
    this.errors = errors;
  }
}

export async function api(path, { method = "GET", body, query } = {}) {
  const params = new URLSearchParams(cleanQuery(query));
  const qs = params.toString();
  const url = `${API_BASE}${path}${qs ? `?${qs}` : ""}`;
  const token = storage.getToken();

  let response;
  try {
    response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiError("Could not reach the server. Please try again.", 0);
  }

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    throw new ApiError(
      payload?.message || "Request failed",
      response.status,
      payload?.errors || []
    );
  }

  return payload;
}

export async function uploadFile(file) {
  const url = `${API_BASE}/uploads`;
  const token = storage.getToken();
  const body = new FormData();
  body.append("file", file);

  let response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body,
    });
  } catch {
    throw new ApiError("Could not reach the server. Please try again.", 0);
  }

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    throw new ApiError(
      payload?.message || "Upload failed",
      response.status,
      payload?.errors || []
    );
  }

  return payload;
}
